module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_6.5ca6b10f.png";